import styles from './Modal.module.scss';
import Privacy from '../../pages/Privacy';
import CloseIcon from '@mui/icons-material/Close';

const Modal = ({state}) => {
    const { isModalOpen, setModalOpen, render } = state;

    let componentToRender = null;

    switch(render){
        case('privacy'):
            componentToRender = <Privacy />;
            break;
        default:
            componentToRender = null;
    }

    return (
        isModalOpen ? 
        <div className={styles.overlay}>
            <div className={styles.modalContainer}>
                <div className={styles.closeModalContainer} onClick={()=>setModalOpen(false)}>
                    <CloseIcon className={styles.icon}/>
                </div>
                {
                    componentToRender
                }
            </div>
        </div> : ""
    )
}

export default Modal;